(() => {
  const controller = document.querySelector('[data-password-game-controller]');
  if (!controller) return;
  const accessKey = 'slomo-box-game-subscription:' + location.hostname;
  const pendingKey = 'slomo-password-game-subscription-pending:' + location.hostname;
  const currentUrl = new URL(location.href);
  const isReturn = currentUrl.searchParams.has('password_game_signup');
  let pending;
  try { pending = JSON.parse(sessionStorage.getItem(pendingKey)); } catch {}
  const age = Date.now() - pending?.submittedAt;
  const validReturn = isReturn && pending?.token === currentUrl.searchParams.get('password_game_signup') && age >= 0 && age < 30 * 60 * 1000;
  const newsletterSuccess = document.querySelector('#PasswordNewsletter [data-password-newsletter-success]');
  if (validReturn && newsletterSuccess && controller.dataset.editor !== 'true') {
    try {
      sessionStorage.setItem(accessKey, '1');
      sessionStorage.setItem('slomo-box-game-subscription-v2:' + location.hostname, JSON.stringify({ version: 2, subscribedAt: Date.now() }));
    } catch {}
    const dialog = document.querySelector('[data-box-game]');
    if (dialog) {
      dialog.dataset.emailGranted = 'true';
      dialog.dataset.justSubscribed = 'true';
    }
  }
  if (isReturn) {
    try { sessionStorage.removeItem(pendingKey); } catch {}
    currentUrl.searchParams.delete('password_game_signup');
    currentUrl.searchParams.delete('customer_posted');
    history.replaceState(history.state, '', currentUrl.pathname + currentUrl.search + currentUrl.hash);
  }
  const initialize = () => {
    const form = document.querySelector('#PasswordNewsletter');
    if (!form || form.dataset.gameTracked === 'true') return;
    form.dataset.gameTracked = 'true';
    form.addEventListener('submit', () => {
      if (controller.dataset.editor === 'true' || !form.checkValidity()) return;
      try {
        const token = crypto.randomUUID();
        sessionStorage.setItem(pendingKey, JSON.stringify({ token, submittedAt: Date.now() }));
        const destination = new URL(location.href);
        destination.searchParams.delete('form_type');
        destination.searchParams.set('password_game_signup', token);
        destination.searchParams.set('customer_posted', 'true');
        destination.hash = 'PasswordNewsletter';
        const returnField = form.querySelector('[name="return_to"]');
        if (returnField) returnField.value = destination.pathname + destination.search + destination.hash;
      } catch {}
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-game-theme]');
    if (!button || document.querySelector('.minimal-header [data-theme-toggle]')) return;
    const isDark = document.documentElement.classList.toggle('theme-dark');
    try { localStorage.setItem('minimal-collections-theme-override-v2', isDark ? 'dark' : 'light'); } catch {}
  }, true);
})();
